"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidTagOrAttributeName = void 0;
const VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_.\-\d]*$/;
const nameCache = {};
function isValidTagOrAttributeName(tagName) {
    if (!(tagName in nameCache)) {
        nameCache[tagName] = VALID_TAG_REGEX.test(tagName);
    }
    return nameCache[tagName];
}
exports.isValidTagOrAttributeName = isValidTagOrAttributeName;
